import React, { useEffect, useState } from "react";
import styles from "./Collapse.module.css";
import { useMediaQuery } from "react-responsive";
import { useLocation } from "react-router-dom";

function Collapse({ title, children, forceOpen = false }) {
  const isMobile = useMediaQuery({ maxWidth: 767 });
  const [collapsedContent, setCollapsedContent] = useState(true);
  
    useState(true);

  // On wider screens, always expand
  const shouldCollapse = isMobile;

  const location = useLocation();

  useEffect(() => {
    // Reset collapsed states when the product changes
    setCollapsedContent(true);
  }, [location]);

  useEffect(() => {
    // If forceOpen is true, ensure content is expanded
    if (forceOpen) {
      setCollapsedContent(false);
    }
  }, [forceOpen]);

  return (
    <div className={styles.Collapse}>
      <section>
        <header
          className={styles.Title}
          style={{ cursor: shouldCollapse ? "pointer" : "default" }}
          onClick={
            shouldCollapse
              ? () => setCollapsedContent((c) => !c)
              : undefined
          }
        >
          {title}
          {shouldCollapse && (
            <span style={{ marginLeft: 8 }}>
              {collapsedContent ? "▼" : "▲"}
            </span>
          )}
        </header>
        {(!shouldCollapse || !collapsedContent) && (
          <div>{children}</div>
        )}
      </section>
    </div>
  );
}

export default Collapse;
